import {
  ColorProperty,
  FlexAnchor,
  FlexAnchorProps,
  Icon,
  IconProperty,
  IconsTheme,
  smBumps,
  Typo,
} from '@wrisk/ui-components'
import React from 'react'

import { ConditionalCover } from '../../../domain'
import {
  tCovers,
  useWriskTranslation,
} from '../../../infrastructure/internationalisation'
import { useConditionalCoverModal } from './useConditionalCoverModal'

interface ConditionalCoverItemProps extends Omit<FlexAnchorProps, 'ref'> {
  conditionalCover: ConditionalCover
  iconSize?: IconProperty
}

export const ConditionalCoverItem: React.FC<ConditionalCoverItemProps> = ({
  conditionalCover,
  typoSize,
  iconSize,
  ...props
}) => {
  const { t } = useWriskTranslation()

  const showConditionalModal = useConditionalCoverModal()

  const { icon, color }: { icon: keyof IconsTheme; color: ColorProperty } =
    conditionalCover.active
      ? {
          icon: 'tick',
          color: 'body',
        }
      : {
          icon: 'cross',
          color: 'bodySecondary',
        }

  return (
    <FlexAnchor
      variant='highlight'
      justifyContent='flex-start'
      py={3}
      px={smBumps}
      onClick={() => showConditionalModal(conditionalCover)}
      {...props}
    >
      <Icon icon={icon} color={color} mr={smBumps} size={iconSize ?? 'medium'} />
      <Typo wordWrap='break-word' typoSize={typoSize} color={color}>
        {t(tCovers(conditionalCover.coverCode, 'name'))}
      </Typo>
    </FlexAnchor>
  )
}
